<template>
  <div class="tva-video-overlay-component">
    <Scroller
      :threshold=".5"
      :top="0"
      :bottom="1"
      v-on:index="index = $event.value"
      v-on:progress="progress = $event.value"
      v-on:offset="offset = $event.value"
      v-on:activeSections="activeSections = $event.value"
      v-on:direction="direction = $event.value"
    >
      <div class="background" ref="background">
        <transition name="fade">
          <div class="quote-overlay" v-if="index === 0">
            <div :class="['opacity-layer', {'active': index !== 0}]"></div>
            <div class="line top"></div>
            <div class="quote">
              <svgicon class="quote-icon-1" icon="quote1" height="20" width="20"></svgicon>
              <p class="text-overlay yellow">{{content.quote_1}}</p>
              <p class="text-overlay">{{content.quote_2}}</p>
              <svgicon class="quote-icon-2" icon="quote2" height="20" width="20"></svgicon>
            </div>
            <div class="line bottom"></div>
          </div>
        </transition>
        <div :class="['video-overlay', index === 0 ? 'expanded' : '']">
          <VideoPlayer
            :src="`${baseUrl}videos/${content.video}${$tvaMq === 'mobile' ? '-M' : ''}.mp4`"
            :muted="index === 0 || progress > 1"
            poster
          />
        </div>
      </div>
      <div ref="foreground">
        <section></section>
        <section></section>
      </div>
    </Scroller>
  </div>
</template>
<script>
import Scroller from "../utilities/Scroller.vue";
import VideoPlayer from "./VideoPlayer.vue";
export default {
  props: ["content"],
  components: {
    Scroller,
    VideoPlayer
  },
  data() {
    return {
      index: 0,
      progress: 0,
      offset: 0,
      activeSections: [],
      direction: "",
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
.tva-video-overlay-component {
  width: 100%;
  margin: 6vw 0;
  .text-overlay.yellow {
    margin-bottom: 0.8em;
  }
  .background {
    position: relative;
    height: 100vh;
    width: 100%;
    background-size: cover;
    background-position: center;
    background: rgb(25, 25, 25);
    z-index: 1;
    overflow: hidden;
  }
  .quote-overlay {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    opacity: 1;
    transition: opacity 1s ease;
    z-index: 1;
    &.fade-enter,
    &.fade-leave-to {
      opacity: 0;
    }
    .opacity-layer {
      position: absolute;
      top: 0px;
      left: 0;
      height: 100%;
      width: 100%;
      background: rgba(0, 0, 0, 0.8);
      z-index: 1;
    }
    .line {
      width: 1px;
      height: 100%;
      background: $eni-yellow;
      z-index: 1;
    }
    .quote {
      z-index: 2;
      max-width: 430px;
      position: relative;
      margin: 40px 0;
      flex-shrink: 0;
      .quote-icon-1.svg-icon {
        position: absolute;
        bottom: -30px;
        left: calc(50% - 11px);
        fill: $eni-yellow;
      }
      .quote-icon-2.svg-icon {
        position: absolute;
        top: -30px;
        left: calc(50% - 11px);
        fill: $eni-yellow;
      }
    }
  }
  .video-overlay {
    width: 100%;
    height: calc(100vh - 96px - 80px);
    margin: calc(96px) 0 80px;
    position: relative;
    z-index: 0;
    transition: all 1s ease;
    &.expanded {
      height: calc(100vh - 96px);
      margin: calc(96px) 0;
    }
  }
  section {
    height: 100vh;
    pointer-events: none;
  }
}
@media (max-width: 1024px) {
  .tva-video-overlay-component {
    .quote-overlay {
      .opacity-layer {
        background: rgba(0, 0, 0, 1);
      }
    }
  }
}
@media (max-width: 720px) {
  .tva-video-overlay-component {
    .quote-overlay {
      padding: 0 20px;
      .opacity-layer {
        background: rgba(0, 0, 0, 1);
      }
    }
  }
}
</style>